<splash-screen class="bg-accent"> </splash-screen>

<router-outlet></router-outlet>
